import { render, staticRenderFns } from "./TablesDashboard.vue?vue&type=template&id=49529a4e"
import script from "./TablesDashboard.vue?vue&type=script&lang=js"
export * from "./TablesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports